import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import OrderFormPage from "./pages/order-form.page";
import ItemDetails from "./pages/item-details";
import SuccessPage from "./pages/success-page";
import ExternalRedirectPage from "./pages/external-redirect.page";
import { createGlobalStyle } from "styled-components";
import { useEffect } from "react";
import CollectLocationForm from "./pages/collectLocationForm";
import CustomerLocationMap from "./pages/customerLocationMap";
import PabiliPadalaCheckOut from "./pages/pabiliPadalaCheckOut";
import LocationPlaceOrder from "./pages/location-place-order";
import OrderFormPageV2 from "./pages/order-form.page-v2";
import { LandingPage } from "./pages/landing";

const GlobalStyle = createGlobalStyle`
  #root {
    background-color: #ffff;
  }
`;

function App() {
  return (
    <>
      <GlobalStyle />

      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/order" element={<OrderFormPage />} /> {/* legit */}
          <Route path="/order-form" element={<OrderFormPageV2 />} />
          <Route path="/item-details" element={<ItemDetails />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/external-browser" element={<ExternalRedirectPage />} />
          <Route path="/collect-location" element={<CollectLocationForm />} />
          <Route
            path="/collect-location-map"
            element={<CustomerLocationMap />}
          />
          <Route
            path="/pabili-padala-checkout"
            element={<PabiliPadalaCheckOut />}
          />
          <Route
            path="/place-order-location"
            element={<LocationPlaceOrder />}
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
